import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import type { ExternalUserReportSimpleStatusEnum } from './../constants.js';
import { Transform } from 'class-transformer';
import type { Constructor } from '@whispli/types';

export class __ExternalUserReportSimple extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Type(() => String)
  @Expose({ groups: ['client', 'server'] })
  public readonly status!: ExternalUserReportSimpleStatusEnum;
  /**
   * @deprecated For backwards-compatibility only. Use reportId
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private whisper_id?: string;

  @Expose({groups: ['client']})
  public get reportId() {
    return this.whisper_id
  }

  public set reportId(value) {
    this.whisper_id = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use reportLabel
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private whisper_label!: string | null;

  @Expose({groups: ['client']})
  public get reportLabel() {
    return this.whisper_label
  }

  public set reportLabel(value) {
    this.whisper_label = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private created_at!: string | null;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use expiresAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private expires_at!: string | null;

  @Expose({groups: ['client']})
  public get expiresAt() {
    return this.expires_at
  }

  public set expiresAt(value) {
    this.expires_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private updated_at!: string | null;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }
}

interface OptionalAlias {
  reportId?: string | undefined;
}
export type ExternalUserReportSimple = Omit<__ExternalUserReportSimple, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'whisper_id' | 'whisper_label' | 'created_at' | 'expires_at' | 'updated_at' | 'reportId'> & OptionalAlias
export const ExternalUserReportSimple = __ExternalUserReportSimple as any as Constructor<ExternalUserReportSimple>
